 <template>
  <div class="Messages">
    <div class="glavni">
      <div class="container">
        <button class="btn btn-info col-1 shadow bg-white-rounded dugme ml-5"><router-link to="/">Home</router-link></button>
        <div
          class="card mt-3"
          v-for="(message, index) in messages"
          :key="index"
          style="min-width: 18rem;"
        >
          <div class="card-body">
            <h5 class="card-title">{{ message.name}}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ message.email }}</h6>
            <p class="card-text">{{ message.body}}</p>
            <button @click="chooseMessage(message.id)" class="btn btn-success mr-2">Edit</button>
            <button @click="deleteMessage(message.id)" class="btn btn-warning">Delete</button>
          </div>
        </div>
     
      <div class="overflow-auto mt-3">
          <b-pagination-nav :link-gen="linkGen" :number-of-pages="lastP" use-router @change="page">
           
          </b-pagination-nav>
      </div>
     
      <div
        class="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalCenterTitle">Edit Message</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="editMessage($event, currentMessage)">
              <input
                class="form-control mb-2"
                type="text"
                name
                id
                placeholder="Name:"
                v-model="name"
              >
              <label for="email"></label>
              <input class="form-control mb-2" type="text" placeholder="Email:" v-model="email">
              <label for="text"></label>
              <textarea class="form-control" name="text" cols="30" rows="5" v-model="body">Your Message:</textarea>
              <div class="row col-12 text-center">
                <div class="col mt-2">
                  <button name="sendMessage" class="mb-3 p-1 btnFont" type="submit">Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
 <script>
import axios from "axios";
export default {
  name: "Messages",
  data() {
    return {
      messages: [],
      lastP: null,
      currentPage: null,
      name: "",
      email: "",
      body: "",
      currentMessage: null
    };
  },
  created() {
    axios
      .get("https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/messages")
      .then(res => {
        console.log(res);
        this.messages = res.data.data.data;
        this.lastP = res.data.data.last_page;
        this.currentPage = res.data.data.current_page;
      })
      .catch(error => console.log(error));
  },
  methods: {
    page(value) {
      axios
        .get(`https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/messages?page=${value}`)
        .then(res => {
          console.log(res);
          this.messages = res.data.data.data;
          this.lastP = res.data.data.last_page;
          this.currentPage = res.data.data.current_page;
        })
        .catch(error => console.log(error));
    },
    editMessage(event, messageId) {
      const formData = {
        name: this.name,
        email: this.email,
        body: this.body
      };
      console.log(formData);
      axios
        .put(`https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/messages/${messageId}`, formData)
        .then(res => {
          console.log(res);
        })
        .catch(error => console.log(error));
      global.$("#exampleModalCenter").modal("hide");
      this.page(this.currentPage);
    },
    deleteMessage(messageId) {
      axios
        .delete(`https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/messages/${messageId}`)
        .then(res => {
          console.log(res);
        })
        .catch(error => console.log(error));
      this.page(this.currentPage);
    },
    chooseMessage(messageId) {
      global.$("#exampleModalCenter").modal("show");
      console.log(messageId);
      this.currentMessage = messageId;
      console.log(this.currentMessage);
      axios
        .get(`https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/messages/${messageId}`)
        .then(res => {
          console.log(res);
          this.name = res.data.data.name;
          this.email = res.data.data.email;
          this.body = res.data.data.body;
        })
        .catch(error => console.log(error));
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    }
  }
};
</script>
 
 <style scoped>
@import '../style.css';

.glavni {
  min-height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #202646;
}

</style>

 